

function HomeContent() {
    return <p>Welcome to the main content area!</p>;
}

export default HomeContent